import { CheckCircle2 } from "lucide-react";
import LocalizedLink from "@/components/LocalizedLink";
import { pickLang, useLanguage } from "@/i18n/LanguageContext";
import {
  SUCCESS_MESSAGE,
  SUCCESS_TITLE,
  GENERIC_STRINGS,
} from "@/pages/contact/requestFormsContent";

/** Post-submit confirmation panel shown inline after a successful submission. */
export default function SuccessState({ onSendAnother, testId = "request-success" }) {
  const { lang } = useLanguage();
  const g = GENERIC_STRINGS[lang];
  return (
    <div
      className="rounded-2xl border border-[color:var(--sas-line)] bg-white p-6 md:p-8"
      data-testid={testId}
      role="status"
      aria-live="polite"
    >
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
        style={{ background: "var(--sas-accent-soft)", color: "var(--sas-accent)" }}
        aria-hidden
      >
        <CheckCircle2 size={22} />
      </div>
      <h2 className="sas-h2">{pickLang(SUCCESS_TITLE, lang)}</h2>
      <p className="sas-body mt-3 text-[15.5px] max-w-xl" data-testid="request-success-message">
        {pickLang(SUCCESS_MESSAGE, lang)}
      </p>
      <div className="mt-6 flex flex-wrap gap-3">
        <button
          type="button"
          onClick={onSendAnother}
          className="sas-btn sas-btn-ghost"
          data-testid="request-send-another"
        >
          {g.sendAnother}
        </button>
        <LocalizedLink to="/contact" className="sas-btn-link" data-testid="request-back-to-contact">
          {g.backToContact}
        </LocalizedLink>
      </div>
    </div>
  );
}
